<div
  class="signature-input pos-rel mt-2"
  [ngClass]="{ readonly: readonly }"
  (click)="openSignaturePad()"
>
  <div
    *ngIf="value && !readonly"
    class="delete-icon"
    (click)="clearSignature(); $event.stopPropagation()"
  >
    <i class="fa-regular fa-xmark text-danger"></i>
  </div>
  <ng-container *ngIf="value">
    <div
      class="signature-image"
      [ngStyle]="{
        backgroundImage: 'url(' + ((value | localImage | async) || 'none') + ')'
      }"
    ></div>
  </ng-container>
  <small class="text-xs color-light">{{
    '#UI_CORE.COMPONENTS.SIGNATURE_INPUT.INFO' | translate
  }}</small>
</div>
